export function getMBNValueHelper(value) {
    let val = value.find(item => item.startsWith("MBN"));
    return val ? val.replace("MBN", "") : "1";
}
//# sourceMappingURL=getMBNValueHelper.js.map